import { DISTINCT_ASYNC_VALUE_OBSERVABLE_PRIVATE } from './privates';
import { AbortReason } from '../../../../misc/reason/built-in/abort-reason';
import { AdvancedAbortController } from '../../../../misc/advanced-abort-controller/implementation';
import { PromiseTry } from '../../../../promises/helpers';
export function AsyncDistinctValueObservableEmit(instance, factory) {
    const privates = instance[DISTINCT_ASYNC_VALUE_OBSERVABLE_PRIVATE];
    if (privates.controller !== null) {
        privates.controller.abort(new AbortReason('Emit before last one finished'));
    }
    const controller = new AdvancedAbortController();
    privates.controller = controller;
    privates.promise = PromiseTry(() => factory.call(instance, controller.signal));
    return controller.signal.wrapPromise(privates.promise)
        .then((value) => {
        privates.context.emit(value);
    });
}
//# sourceMappingURL=functions.js.map